import SelectFlexibility from './SelectFlexibility';

export default SelectFlexibility;
